// RegionHandler.tsx
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { setRegion } from 'core/state/region/actions'

const RegionHandler = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const region = searchParams.get('region')

    if (region) {
      dispatch(setRegion(region))

      searchParams.delete('region')
      history.replace({
        pathname: location.pathname,
        search: searchParams.toString()
      })
    }
  }, [location, dispatch, history])

  return null
}

export default RegionHandler
